var map = {
	"./call.svg": 3043,
	"./email.svg": 3044,
	"./food.svg": 3045,
	"./house.svg": 3046,
	"./people.svg": 3047,
	"./task.svg": 3048,
	"./whatsapp.svg": 3049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 633;